import { useTranslation } from 'react-i18next';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import CDateUpdatedAtom from '../components/CDateUpdatedAtom';

import CInvestDisclaimer from '../components/CInvestDisclaimer';

import React, { useEffect } from 'react';

import useInvestDashboardKpis from '../hooks/dashboard/useInvestDashboardKpis';

import FUserFirstLoginDialog from '../../user/features/FUserFirstLoginDialog';
import CInfoKpi from '../components/CInfoKpi';
import useInvestFunds from '../hooks/fund/useInvestFunds';
import { Helmet } from 'react-helmet';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import FUserCompanySelect from '../../user/features/FUserCompanySelect';
import investmentPageLang from '../langs/investmentPageLang';
import CAppTitle from '../../../app/components/CAppTitle';
import { useAppSettings } from '../../../app/features/settings/providers/AppSettingsProvider';
import langInvestWordLang from '../langs/langInvestWordLang';
import { useAppNavigationContext } from '../../../app/features/navigation/providers/AppNavigationProvider';
import VInvestDashboard from '../views/dashboard/VInvestDashboard';
import VInvestDashboardMultiExpertises from '../views/dashboard/VInvestDashboardMultiExpertises';
import investExpertiseListedAssetsLang from '../langs/investExpertiseListedAssetsLang';

const PInvestDashboard = () => {
	const { t } = useTranslation();

	const appSettings = useAppSettings();
	const authContext = useAuthContext();

	const navigationContext = useAppNavigationContext();

	useEffect(() => {
		if (navigationContext.displayCurrencySelector === false) {
			navigationContext.setDisplayCurrencySelector(true);
		}
	}, [navigationContext]);

	const { funds: allFunds } = useInvestFunds();
	const { dataUpdatedOn } = useInvestDashboardKpis();

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<>
			<Helmet>
				<title>
					{authContext.authContext === 'employee' ? '[E] ' : ''} {t(investmentPageLang.dashboard_title.tag)} -{' '}
					{authContext.currentCompany ? authContext.currentCompany.name : ''}
				</title>
			</Helmet>
			<FUserFirstLoginDialog />
			{allFunds && (
				<>
					{isMobile && (
						<Box sx={{ marginBottom: '15px' }}>
							<FUserCompanySelect />
						</Box>
					)}
					<CAppTitle
						title={t(investmentPageLang.dashboard_title.tag)}
						id="invest-dashboard-title"
						subtitle={
							allFunds && allFunds?.some((x) => x.typeTag === 'listed_assets') ? (
								<>{t(investExpertiseListedAssetsLang.global_subtitle.tag)}</>
							) : (
								<>
									{appSettings.realizationStatus === 'realized'
										? t(langInvestWordLang.realized_funds.tag) + ' | '
										: appSettings.realizationStatus === 'unrealized'
										? t(langInvestWordLang.unrealized_funds.tag) + ' | '
										: ''}
									<CDateUpdatedAtom isEstimated date={dataUpdatedOn} />
									{(appSettings.realizationStatus === 'all' ||
										appSettings.realizationStatus === 'realized') &&
										allFunds &&
										allFunds.some((x) => x.isRealized) && <CInfoKpi />}
								</>
							)
						}
					/>

					{allFunds.every((x) => x.typeTag === 'private_credit') ? (
						<VInvestDashboard />
					) : (
						<VInvestDashboardMultiExpertises />
					)}
				</>
			)}

			<CInvestDisclaimer />
		</>
	);
};

export default PInvestDashboard;
